<td class="mdl-data-table__cell--non-numeric">Last Updated</td>
<td class="mdl-data-table__cell--non-numeric">
    Shows the date of last database optimization
</td>
<td>{{instance?.lastOptimizedFormatted}}</td>
<td>
    <mat-icon *ngIf="!needFix" style="color: green;" title="Optimized less than month ago">
        check
    </mat-icon>
    <mat-icon *ngIf="needFix" style="color: red;" title="Optimized more than month ago">
        close
    </mat-icon>
</td>
<td>
    <app-action-button-with-embedded-spinner class="process-actions-button small-action-button" [disabled]="!canStart"
        [actionObservable]="fix.bind(this)" [icon]="'handyman'" [hint]="'Optimize database storage'">
    </app-action-button-with-embedded-spinner>
</td>
